import { View } from 'react-native';
import Animated from 'react-native-reanimated';
import { useUserImageLogic } from './UserImage.logic';
import { styles } from './UserImage.style';
import { ContentUserImageProps } from '@photosi/rn-components/user-image/content-user-image/ContentUserImage.types';
import { IUserImageModel } from '../../store/_models/userImage';
import { observer } from 'mobx-react-lite';
import { Image } from 'expo-image';
import { useResponsiveScale } from '../../contexts/ResponsiveScaleContext';
import { useUserImageTransform } from '../../hooks/useUserImageTransform';

export type UserImageProps = ContentUserImageProps & {
  userImage: IUserImageModel;
  showOverflow?: boolean;
  disableSwapImageAnimation?: boolean;
};

export const UserImage = observer((props: UserImageProps) => {
  const { userImage, showOverflow, currentImageAnimatedStyle, nextImageAnimatedStyle, currentImage, nextImage } =
    useUserImageLogic(props);

  const { responsiveScaleSV, responsiveScale } = useResponsiveScale();

  const { tempRotationSV, tempZoomSV, tempPanSV } = useUserImageTransform({ userImage });

  // NUOVO: Animated style per trasformazioni con SharedValues
  // const animatedTransformStyle = useAnimatedStyle(() => {
  //   const scaledSize = {
  //     width: userImage.width * userImage.scale,
  //     height: userImage.height * userImage.scale,
  //   };
  //
  //   const scaledOffset = {
  //     x: userImage.offsetX * scaledSize.width,
  //     y: userImage.offsetY * scaledSize.height,
  //   };
  //
  //   const userOffset = {
  //     x: userImage.userOffsetXTemp ?? 0,
  //     y: userImage.userOffsetYTemp ?? 0,
  //   };
  //
  //   const responsiveOffset = {
  //     x: userImage.offsetXTemp ?? scaledOffset.x * responsiveScaleSV.value + userOffset.x,
  //     y: userImage.offsetYTemp ?? scaledOffset.y * responsiveScaleSV.value + userOffset.y,
  //   };
  //
  //   const responsiveSize = {
  //     width: scaledSize.width * responsiveScaleSV.value,
  //     height: scaledSize.height * responsiveScaleSV.value,
  //   };
  //
  //   console.log('DEBUG-ROTATION - UserImage (animatedTransformStyle): ', {
  //     responsiveSize: responsiveSize,
  //     scaledSize: scaledSize,
  //     scaledOffset: scaledOffset,
  //     responsiveOffset: responsiveOffset,
  //     transform: [
  //       { translateX: responsiveOffset.x ?? responsiveOffset.x },
  //       { translateY: responsiveOffset.y ?? responsiveOffset.y },
  //       { rotate: `${tempRotationSV?.value ?? userImage.rotationDeg}deg` },
  //     ],
  //   });
  //
  //   return {
  //     width: responsiveSize.width,
  //     height: responsiveSize.height,
  //     transform: [
  //       { translateX: responsiveOffset.x ?? responsiveOffset.x },
  //       { translateY: responsiveOffset.y ?? responsiveOffset.y },
  //       { rotate: `${tempRotationSV?.value ?? userImage.rotationDeg}deg` },
  //     ],
  //   };
  // });

  return (
    <View
      style={[
        styles.container,
        showOverflow ? styles.oveflowVisible : styles.oveflowHidden,
        currentImage.isUpdating && styles.layerUpdate,
      ]}
    >
      {/* Current Image with crossfade opacity animation */}
      <Animated.View
        style={[
          currentImageAnimatedStyle,
          {
            width: currentImage.width * currentImage.scale * responsiveScale,
            height: currentImage.height * currentImage.scale * responsiveScale,
          },
          {
            transform: [
              {
                translateX:
                  currentImage.offsetX * currentImage.width * currentImage.scale * responsiveScale +
                  (currentImage.userOffsetXTemp ?? 0),
              },
              {
                translateY:
                  currentImage.offsetY * currentImage.height * currentImage.scale * responsiveScale +
                  (currentImage.userOffsetYTemp ?? 0),
              },
              { rotate: `${currentImage.rotationDeg}deg` },
            ],
          },
        ]}
      >
        <Image
          //@ts-ignore
          draggable="false"
          crossOrigin="anonymous"
          source={{ uri: currentImage.url }}
          style={styles.image}
        />
      </Animated.View>

      {/* Next Image with crossfade opacity animation - positioned absolutely to overlay current image */}
      {nextImage && (
        <Animated.View
          style={[
            nextImageAnimatedStyle,
            {
              position: 'absolute',
              top: 0,
              left: 0,
            },
            {
              width: nextImage.width * nextImage.scale * responsiveScale,
              height: nextImage.height * nextImage.scale * responsiveScale,
            },
            {
              transform: [
                {
                  translateX:
                    nextImage.offsetX * nextImage.width * nextImage.scale * responsiveScale +
                    (nextImage.userOffsetXTemp ?? 0),
                },
                {
                  translateY:
                    nextImage.offsetY * nextImage.height * nextImage.scale * responsiveScale +
                    (nextImage.userOffsetYTemp ?? 0),
                },
                { rotate: `${nextImage.rotationDeg}deg` },
              ],
            },
          ]}
        >
          <Image
            //@ts-ignore
            draggable="false"
            crossOrigin="anonymous"
            // source={{ uri: nextImageUri }}
            source={{ uri: nextImage.url }}
            style={styles.image}
          />
        </Animated.View>
      )}
    </View>
  );
});
